import { StorageKeys } from 'shared/config/cookie'

import { deleteCookie, getCookie, setCookie } from './cookie'
import {
  deleteLocalStorage,
  getLocalStorage,
  setLocalStorage,
} from './localStorage'
import { DefaultKeyToStorage } from './model'
import { SaveStorage } from './types'

export const TokenStorage = {
  saveToStorage({ saveLocal, value, key = DefaultKeyToStorage }: SaveStorage) {
    if (saveLocal) {
      setLocalStorage({ value, key })
      return
    }

    setCookie({ value, key })
  },
  getFromStorage(key: string = DefaultKeyToStorage): string {
    const localStorage = getLocalStorage(key)

    if (localStorage) {
      return localStorage
    }

    const cookie = getCookie(StorageKeys.access)

    if (cookie) {
      return cookie
    }

    return localStorage || cookie || ''
  },
  isSaved: (key: string = DefaultKeyToStorage) => {
    const localStorage = getLocalStorage(key)

    return !!localStorage
  },

  deleteStorage() {
    deleteLocalStorage(DefaultKeyToStorage)
    deleteCookie(DefaultKeyToStorage)
  },
}
